module.exports = __webpack_public_path__ + "static/media/24UHCHR6.ca25b5a8.jpg";